import React from 'react';
import PropTypes from 'prop-types';
import { RatingLabel, ExtraRating } from './ratingStyles';
import RatingStars from 'core/components/RatingStars';

const Rating = ({ label, score, minimal }) => score && (
	<ExtraRating>
		<RatingStars stars={score} />
		{!minimal && label && (
			<RatingLabel>{label}</RatingLabel>
		)}
	</ExtraRating>
);

Rating.propTypes = {
	label: PropTypes.string,
	score: PropTypes.number,
	minimal: PropTypes.bool,
};

export default Rating;
